<template>
    <el-dialog :title="$t('serviceTickets.selectCategory') + ' ' + ticketId + ' ' + $t('serviceTickets.details')"
               :visible.sync="showDialog"
               @open="loadTicket"
               @close="closeDialog"
               width="650px"
               append-to-body
               :close-on-click-modal="false">
        <el-row :gutter="10">
            <el-col :span="9">
                <dl>
                    <dt v-if="details.confirmation">{{details.confirmationText}}</dt>
                    <dt>Opened by</dt>
                    <dd>{{details.openedBy}}</dd>
                    <dt>Opened on</dt>
                    <dd>{{details.raisedOn | date}}</dd>
                    <dt>Dispatched to</dt>
                    <dd v-html="details.dispatchedTo"></dd>
                    <dt>Urgency</dt>
                    <dd>{{details.urgency}}</dd>
                    <dt>Overtime</dt>
                    <dd>{{details.overtimeApproved ? $t('common.yes') : $t('common.no') }}</dd>
                </dl>
            </el-col>
            <el-col :span="9">
                <dl>
                    <dt>{{$t('serviceTickets.customerName')}}</dt>
                    <dd>{{details.customerName}}</dd>
                    <dt>{{$t('serviceTickets.address')}}</dt>
                    <dd>{{details.customerAddress}}</dd>
                    <dt>{{$t('serviceTickets.phone')}}</dt>
                    <dd>{{details.phone}}</dd>
                    <dt>{{$t('serviceTickets.callBy')}}</dt>
                    <dd>{{details.callBy}}</dd>
                    <dt v-if="details.callerPhoneNumber">{{$t('serviceTickets.callerPhone')}}</dt>
                    <dd>{{details.callerPhoneNumber == null ? '' : details.callerPhoneNumber}}</dd>
                    <dt v-if="details.secondCallerPhoneNumber">Second Contact</dt>
                    <dd>{{details.secondCallerPhoneNumber == null ? '' : details.secondCallerPhoneNumber}}</dd>
                    <dt v-if="details.callerEmail">Caller Email</dt>
                    <dd>{{details.callerEmail == null ? '' : details.callerEmail}}</dd>
                    <dt>{{$t('serviceTickets.status')}}</dt>
                    <dd>
                        <template v-if="$isAdmin">
                            <el-select v-model="details.status"
                                       @change="changeStatus"
                                       :placeholder="$t('serviceTickets.select')">
                                <el-option v-for="item in statuses"
                                           :key="item.status"
                                           :label="item.name"
                                           :value="item.status">
                                </el-option>
                            </el-select>
                        </template>
                        <span v-else>{{details.statusText}}</span>
                    </dd>
                </dl>
            </el-col>
            <el-col :span="6">
                <dl>
                    <dt>{{$t('serviceTickets.model')}}</dt>
                    <dd>{{details.model}}</dd>
                    <dt>{{$t('serviceTickets.serial')}}</dt>
                    <dd>{{details.serialNumber}}</dd>
                    <dt>{{$t('serviceTickets.coverage')}}</dt>
                    <dd>{{details.coverage}}</dd>
                    <dt>{{$t('serviceTickets.gasType')}}</dt>
                    <dd>{{details.gasType}}</dd>
                    <dt>{{$t('serviceTickets.warrEnd')}}</dt>
                    <dd>{{details.warrantyEnd | date}}</dd>
                </dl>
            </el-col>
        </el-row>
        <el-row>
            <el-button :disabled="loading" style="font-weight: bold;"
                       @click="showPartsNeededDialog = true"
                       v-if="$isAdmin && details.status == 5">Parts Needed</el-button>
        </el-row>
        <el-row class="mb-3">
            <h4>{{$t('serviceTickets.liveSupportAvailability')}}: 1 800-387-6847</h4>
            <ul class="support-hours">
                <li><strong>{{$t('serviceTickets.mondayToFriday')}}:</strong>{{$t('serviceTickets.mondayToFridayHours')}}</li>
                <li><strong>{{$t('serviceTickets.afterHours')}}:</strong>{{$t('serviceTickets.afterHoursHours')}}</li>
                <li><strong>{{$t('serviceTickets.afterHoursWeekends')}}:</strong>{{$t('serviceTickets.afterHoursWeekendsHours')}}</li>
            </ul>
            <h4>{{$t('serviceTickets.hardtEqTechnResources')}}</h4>
            <p>
                {{$t('serviceTickets.hardtEqTechnResourcesText1')}}<br>
                {{$t('serviceTickets.hardtEqTechnResourcesText2')}}
                <a href="https://hardtinfotechsupport.com"
                   target="_blank"
                   rel="noopener noreferrer">
                    https://hardtinfotechsupport.com
                </a>
            </p>
        </el-row>
        <el-row v-if="details.note">
            <h4>{{$t('serviceTickets.communicationRequirements')}}</h4>
            {{details.note}}
        </el-row>
        <el-row v-if="details.productNote">
            <h4>{{$t('serviceTickets.productNote')}}</h4>
            {{details.productNote}}
        </el-row>
        <el-row>
            <h4>{{$t('serviceTickets.symptoms')}}</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <table style="width: 100%;">

                    <tbody v-for="complaint in details.complaints"
                           :key="complaint.code">
                        <tr>
                            <td>
                                <h4>{{$t('serviceTickets.symptomCodes')}}</h4>
                            </td>
                            <td>
                                <h4>{{$t('serviceTickets.description')}}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td>{{complaint.code}}</td>
                            <td>{{complaint.description}}</td>
                        </tr>
                        <tr>
                            <td>
                                <h4 style="white-space:pre" v-if="ShowMandatoryParts(complaint)">{{$t('serviceTickets.mandatoryParts')}}</h4>
                            </td>
                            <td>
                                <!--<h4 v-if="ShowMandatoryParts(complaint)">Description</h4>-->
                            </td>
                        </tr>
                        <tr>
                            <td v-if="ShowMandatoryParts(complaint)" style="white-space:pre">{{ShowMandatoryParts(complaint)}}</td>
                            <td v-if="ShowMandatoryParts(complaint)" style="white-space:pre">{{ShowDescriptionForMandatoryParts(complaint)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <h4 style="white-space:pre" v-if="ShowRecommendedParts(complaint)">{{$t('serviceTickets.recommendedParts')}}</h4>
                            </td>
                            <td>
                                <!--<h4 v-if="ShowRecommendedParts(complaint)">Description</h4>-->
                            </td>
                        </tr>
                        <tr>
                            <td v-if="ShowRecommendedParts(complaint)" style="white-space:pre">{{ShowRecommendedParts(complaint)}}</td>
                            <td v-if="ShowRecommendedParts(complaint)" style="white-space:pre">{{ShowDescriptionForRecommendedParts(complaint)}}</td>
                        </tr>
                        <tr>
                            <td>
                                <hr />
                            </td>
                        </tr>
                    </tbody>

                </table>
            </el-scrollbar>
        </el-row>
        <el-row v-if="$isAdmin || (details.comments && details.comments.lenght > 0)">
            <h4>{{$t('serviceTickets.comments')}}</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <ul class="comment-box">
                    <li v-for="comment in details.comments"
                        :key="comment.id">
                        <p>
                            {{comment.message}}

                        </p>
                        <!--<i
                      size="mini"
                      @click="editComment(comment)"
                    >
                      <i class="el-icon-edit"></i>
                    </i>-->
                        <i size="mini"
                           @click="deleteComment(comment)">
                            <i class="el-icon-delete"></i>
                        </i>
                        <small>On {{ showCommentFullTime(comment) }} by {{comment.author}}</small>
                    </li>
                </ul>
            </el-scrollbar>
            <el-form v-loading="loading"
                     ref="form"
                     :model="form"
                     size="small"
                     v-if="$isAdmin">
                <el-form-item prop="comment"
                              :show-message="false"
                              class="comment-input">
                    <el-input type="textarea"
                              size="small"
                              :rows="4"
                              v-model="form.comment"
                              :placeholder="$t('serviceTickets.newTicketComment')">
                    </el-input>
                </el-form-item>
                <el-button class="comment-button"
                           @click="submitComment">{{$t('serviceTickets.saveComment')}}</el-button>
            </el-form>
        </el-row>
        <el-row v-if="($isAdmin || (details.escalationCommentNextStep && details.escalationCommentNextStep.lenght > 0)) && details.status == 5">
            <h4>Escalation Next Step</h4>
            <el-scrollbar style="margin-bottom: 10px;">
                <ul class="comment-box">
                    <li v-for="escalationCommentNextStep in details.escalationCommentNextStep"
                        :key="escalationCommentNextStep.id">
                        <p>
                            {{escalationCommentNextStep.message}}

                        </p>
                        <!--<i
                      size="mini"
                      @click="editComment(comment)"
                    >
                      <i class="el-icon-edit"></i>
                    </i>-->
                        <i size="mini"
                           @click="deleteEscalationCommentNextStep(escalationCommentNextStep)">
                            <i class="el-icon-delete"></i>
                        </i>
                        <small>On {{ showCommentFullTime(escalationCommentNextStep) }} by {{escalationCommentNextStep.author}}</small>
                    </li>
                </ul>
            </el-scrollbar>
            <el-form v-loading="loading"
                     ref="form"
                     :model="form"
                     size="small"
                     v-if="$isAdmin">
                <el-form-item prop="escalationCommentNextStep"
                              :show-message="false"
                              class="comment-input">
                    <el-input type="textarea"
                              size="small"
                              :rows="4"
                              v-model="form.escalationCommentNextStep"
                              placeholder="Escalation Next Step">
                    </el-input>
                </el-form-item>
                <el-button class="comment-button"
                           @click="submitEscalationCommentNextStep">Save Escalation Next Step</el-button>
            </el-form>
        </el-row>
        <el-row v-if="details.status == 5">
            <div style="margin-bottom: 10px; margin-top: 10px; display: flex; justify-content: flex-end;">
                <el-button :disabled="loading"
                           @click="showSubscriptionDialog = true"
                           type="primary">Subscription List</el-button>
            </div>
        </el-row>
        <el-row style="margin-top: 20px;">
            <el-upload style="text-align:center;"
                       name="attachments"
                       drag
                       multiple
                       :file-list="details.attachments"
                       :auto-upload="false"
                       :limit="10"
                       action=""
                       :on-change="attachmentChanged"
                       :on-remove="attachmentRemoved"
                       :on-preview="handlePreview"
                       v-if="$isAdmin">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    {{$t('serviceTickets.dropFile')}}
                    <em>{{$t('serviceTickets.clicktoUpload')}}</em>
                </div>
            </el-upload>
        </el-row>
        <el-dialog :visible.sync="showImagePreview"
                   width="60%"
                   append-to-body>
            <img style="width: 100%;"
                 v-bind:src="fileUrlPreview"
                 alt=""
                 v-if="fileExtension!=='pdf'" />
            <embed v-bind:src="fileUrlPreview"
                   style="width: 100%; height: 600px;"
                   type='application/pdf'
                   v-if="fileExtension==='pdf'">
            <el-button @click="showImagePreview = false">{{$t('serviceTickets.close')}}</el-button>
        </el-dialog>
        <el-dialog :visible.sync="showRsMessage"
                   width="30%"
                   append-to-body
                   :title="$t('serviceTickets.customerRs')">
            <p>
                {{$t('serviceTickets.rsMessage1')}}<br>
                {{$t('serviceTickets.rsMessage2')}}
            </p>
            <el-button @click="showRsMessage = false">{{$t('serviceTickets.ok')}}</el-button>
            <el-button @click="viewrsprocedures">{{$t('serviceTickets.viewRsProcedures')}}</el-button>
        </el-dialog>
        <div slot="footer">
            <div style="margin-bottom: 10px;">
                <el-button :disabled="loading" style="color: red; font-weight: bold;"
                           @click="showGenerateAuthDialog = true"
                           v-if="$isAdmin && authForm.id == 0">{{$t('serviceTickets.generateAuth')}}</el-button>
                <el-button :disabled="loading" style="color: red; font-weight: bold;"
                           @click="showGenerateAuthDialog = true"
                           v-if="$isAdmin && authForm.id">{{$t('serviceTickets.seeAuth')}}</el-button>
                <el-button :disabled="loading"
                           @click="showResendDialog = true"
                           v-if="$isAdmin">{{$t('serviceTickets.resend')}}</el-button>
                <el-button :disabled="loading"
                           type="primary"
                           @click="resolveTicket"
                           v-if="details.status === 1 && $isAdmin">{{$t('serviceTickets.resolveTicket')}}</el-button>
                <el-button :disabled="loading"
                           type="primary"
                           @click="reopenTicket"
                           v-if="details.status === 2 && $isAdmin">{{$t('serviceTickets.reopen')}}</el-button>
                <el-button :disabled="loading"
                           @click="print"
                           v-if="$isAdmin">{{$t('serviceTickets.print')}}</el-button>
                <el-button :disabled="loading"
                           @click="closeDialog"
                           v-if="$isAdmin">{{$t('serviceTickets.close')}}</el-button>
                <el-button :disabled="loading"
                           type="primary"
                           @click="accept"
                           v-if="$isUser">{{$t('serviceTickets.accept')}}</el-button>
                <el-button :disabled="loading"
                           @click="showRejectedReason = true"
                           v-if="$isUser">{{$t('serviceTickets.reject')}}</el-button>
            </div>
            <el-button :disabled="loading"
                       type="primary"
                       @click="updateTicket"
                       v-if="$isAdmin">{{$t('serviceTickets.update')}}</el-button>
        </div>
        <send-email-dialog :visible="showResendDialog"
                           :formChangeEmail="formChangeEmail"
                           @save="sendEmail"></send-email-dialog>
        <el-dialog :visible.sync="showRejectedReason"
                   width="50%"
                   append-to-body>
            <el-form ref="rejectedReasonForm"
                     :model="rejectedReasonForm"
                     :rules="rejectedReasonRules">
                <el-form-item prop="rejectedReason"
                              :label="$t('serviceTickets.rejectServiceDispatch')">
                    <el-input type="textarea"
                              size="small"
                              :rows="4"
                              v-model="rejectedReasonForm.rejectedReason">
                    </el-input>
                </el-form-item>
                <el-button type="primary"
                           @click="reject">{{$t('serviceTickets.ok')}}</el-button>
            </el-form>
        </el-dialog>
        <el-dialog title="Parts Needed" :visible.sync="showPartsNeededDialog"
                   width="650px"
                   append-to-body>
            <el-form ref="partsNeededForm"
                     :model="partsNeededForm"
                     :rules="partsNeededRules">
                <el-form-item prop="salesOrderNumber"
                              label="Sales Order #">
                    <el-input v-model.number="salesOrderNumber" type="number"></el-input>
                </el-form-item>
                <el-form-item prop="trackingNumber"
                              label="Tracking #">
                    <el-input v-model="trackingNumber"></el-input>
                </el-form-item>
                <el-form-item prop="workflowStage" label="Workflow Stage">
                    <el-select v-model="partsNeededForm.workflowStage"
                               class="full-width">
                        <el-option :value="1"
                                   label="Dispatched"></el-option>
                        <el-option :value="2"
                                   label="Pending Tech ETA (1)"></el-option>
                        <el-option :value="3"
                                   label="Tech ETA (1)"></el-option>
                        <el-option :value="4"
                                   label="Tech onsite (1)"></el-option>
                        <el-option :value="5"
                                   label="Parts needed"></el-option>
                        <el-option :value="6"
                                   label="Pending Parts Order / Parts Ordered"></el-option>
                        <el-option :value="7"
                                   label="Sales Order #"></el-option>
                        <el-option :value="8"
                                   label="Parts Shipped"></el-option>
                        <el-option :value="9"
                                   label="Tracking # (allow for more than one)"></el-option>
                        <el-option :value="10"
                                   label="Parts Estimated delivery (ETD)"></el-option>
                        <el-option :value="11"
                                   label="Parts Delivered"></el-option>
                        <el-option :value="12"
                                   label="Pending Tech ETA (2)"></el-option>
                        <el-option :value="13"
                                   label="Tech ETA (2)"></el-option>
                        <el-option :value="14"
                                   label="Tech onsite (2)"></el-option>
                        <el-option :value="15"
                                   label="Job Completed"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="escalationContactName" label="SVC Co. Escalation Contact Name">
                    <el-input v-model="partsNeededForm.escallationContactName"></el-input>
                </el-form-item>
                <el-form-item prop="escalationContactPhone" label="SVC Co. Escalation Contact Phone">
                    <el-input v-model="partsNeededForm.escallationContactPhone"></el-input>
                </el-form-item>
                <el-form-item prop="escalationContactEmail" label="SVC Co. Escalation Contact E-Mail">
                    <el-input v-model="partsNeededForm.escallationContactEmail"></el-input>
                </el-form-item>
                <el-form-item prop="escalatedBy" label="Escalated By">
                    <el-input v-model="partsNeededForm.escalatedBy"></el-input>
                </el-form-item>
                <h3>
                    Parts
                    <el-button size="mini"
                               @click="showAddPart">Click Here To Add Parts</el-button>
                </h3>
                <el-table v-if="partsForm.length > 0" :data="partsForm"
                          size="mini"
                          class="tablewithshading">
                    <el-table-column label="Part #">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark"
                                        :content="scope.row.part.name"
                                        placement="top">
                                <el-tag type="info"
                                        size="small"
                                        :disable-transitions="true"
                                        style="margin-right:5px;">{{scope.row.part.partNo}}</el-tag>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="part.name"
                                     label="Name"
                                     width="250"></el-table-column>
                    <el-table-column label="Price">
                        <template slot-scope="scope">
                            {{scope.row.part.price | money}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="part.extendedPrice"
                                     label="Ext. Price">
                        <template slot-scope="scope">
                            {{scope.row.part.extendedPrice * scope.row.quantity | money}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="quantity"
                                     label="Quantity"></el-table-column>
                    <el-table-column label="Operations"
                                     align="center">

                    </el-table-column>
                </el-table>
            </el-form>
            <div style="margin-bottom: 10px; margin-top: 10px; display: flex; justify-content: flex-end;">
                <el-button type="primary"
                           @click="addEscalationPartNeeded">Add</el-button>
                <el-button @click="closePartsNeededDialog">Close</el-button>

            </div>
        </el-dialog>
        <add-part-dialog :visible.sync="showAddPartsDialog"
                         :serviceCompanyId="details.serviceCompanyId"
                         :productId="details.productId"
                         :isNotWarrantyClaim="isNotWarrantyClaim"
                         @part-added="partAdded"
                         @dialogClosed="partDialogClosed"></add-part-dialog>
        <el-dialog :title="$t('serviceTickets.generateAuth')" :visible.sync="showGenerateAuthDialog"
                   width="50%"
                   append-to-body>
            <el-form ref="authForm"
                     :model="authForm">
                <el-form-item v-if="authForm.authNumber" prop="authNumber"
                              :label="$t('serviceTickets.currentAuth')" style="font-weight: 700">
                    <span style="font-weight: normal;">{{ authForm.authNumber }}</span>
                </el-form-item>
                <el-form-item prop="partNumber"
                              :label="$t('serviceTickets.partNumber')">
                    <el-input v-model="authForm.partNumber"></el-input>
                </el-form-item>
                <el-form-item prop="qty"
                              label="QTY">
                    <el-input v-model="authForm.qty"></el-input>
                </el-form-item>
                <el-form-item prop="techName"
                              :label="$t('serviceTickets.techName')">
                    <el-input v-model="authForm.techName"></el-input>
                </el-form-item>
                <el-button type="primary"
                           @click="generateAuth">{{$t('serviceTickets.generate')}}</el-button>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="showSubscriptionDialog"
                   width="650px"
                   style="margin-left: -15px;"
                   append-to-body>
            <el-scrollbar style="margin-bottom: 10px;">
                <h4>Subscription List</h4>
                <el-table :data="subscriberForm"
                          size="mini">
                    <el-table-column prop="name" width="90"
                                     label="Name">
                    </el-table-column>
                    <el-table-column prop="email" width="90"
                                     label="Email">
                    </el-table-column>
                    <el-table-column prop="sms" width="90"
                                     label="Phone Number">
                    </el-table-column>
                    <el-table-column prop="IsSubscribedByEmail" label="Email Subscription" width="100">
                        <template slot-scope="scope">
                            <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                <el-checkbox class="checkbox"
                                             v-model="scope.row.isSubscribedByEmail"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="IsSubscribedBySms" label="SMS Subscription" width="100">
                        <template slot-scope="scope">
                            <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                                <el-checkbox class="checkbox"
                                             v-model="scope.row.isSubscribedBySms"></el-checkbox>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-bottom: 10px; margin-top: 10px; display: flex; justify-content: flex-end;">
                    <el-button type="primary"
                               @click="updateSubscriber">Update</el-button>
                </div>
            </el-scrollbar>
        </el-dialog>
    </el-dialog>
</template>
<script>
    import SendEmailDialog from "./SendEmailDialog";
    import AddPartDialog from "./AddPartDialog";
    import api from "../api";
    export default {
        name: "service-ticket-details-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            ticketId: {
                required: true
            }
        },
        components: {
            SendEmailDialog,
            AddPartDialog
        },
        data() {
            return {
                form: {
                    comment: "",
                    escalationCommentNextStep: "",
                },
                details: {},
                serviceCompanyId: null,
                productId: null,
                selectedPart: undefined,
                showAddPartsDialog: false,
                partsNumber: null,
                partsForm: [],
                showSubscriptionDialog: false,
                subscriberForm: [],
                newParts: [],
                partsRules: {},
                isNotWarrantyClaim: false,
                rules: {
                    comment: [
                        {
                            message: this.$t('common.pleaseEnterCommentText'),
                            trigger: "blur"
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                statuses: [],
                fileUrlPreview: null,
                showImagePreview: false,
                showRsMessage: false,
                fileExtension: null,
                showResendDialog: false,
                showGenerateAuthDialog: false,
                showPartsNeededDialog: false,
                formChangeEmail: {
                    serviceCompany: null,
                    phone: null,
                    email: null,
                    useCustom: false
                },
                serviceCompanyId: null,
                showRejectedReason: false,
                isPendingPart: false,
                rejectedReasonForm: {
                    rejectedReason: null
                },
                partsNeededForm: {
                    salesOrderNumber: "",
                    trackingNumber: "",
                    workflowStage: null,
                    smsSubscription: false,
                    emailSubscription: false,
                    escallationContactName: "",
                    escallationContactPhone: "",
                    escallationContactEmail: "",
                    escalatedBy: "",
                    parts: []
                },
                partsNeededRules: {

                },
                salesOrderNumber: "",
                trackingNumber: "",
                rejectedReasonRules: {
                    rejectedReason: [
                        {
                            message: this.$t('common.pleaseEnterRejectedReason'),
                            required: true
                        },
                        {
                            validator: (rule, value, callback) => {
                                if (
                                    this.showRejectedReason &&
                                    (!this.rejectedReasonForm.rejectedReason ||
                                        this.rejectedReasonForm.rejectedReason == "")
                                ) {
                                    callback(new Error(this.$t('common.invoiceNumberMustBeUnique')));
                                } else {
                                    callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ]
                },
                authForm: {
                    partNumber: "",
                    qty: 0,
                    techName: "",
                    id: 0,
                    serviceTicketId: 0,
                    authNumber: "",
                    date: "",
                    authNumberString:""
                }
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
                this.loadStatuses();
            },
            salesOrderNumber: function (val) {
                if (this.partsNeededForm.trackingNumber == "") {
                    if (val != "")
                        this.partsNeededForm.workflowStage = 6;
                    else
                        this.partsNeededForm.workflowStage = null;
                }
                this.partsNeededForm.salesOrderNumber = val;
            },
            trackingNumber: function (val) {
                if (val != "")
                    this.partsNeededForm.workflowStage = 8;
                else
                    this.partsNeededForm.workflowStage = null;
                this.partsNeededForm.trackingNumber = val;
            }
        },
        methods: {
            loadTicket() {
                if (this.ticketId) {
                    this.loading = true;
                    api.getTicket(this.ticketId).then(response => {
                        this.loading = false;
                        api.getIsPendingPart(this.ticketId).then(responsePendingPart => {
                            this.isPendingPart = responsePendingPart.data;
                        });
                        if (response.data.success) {
                            this.details = Object.assign({}, response.data.ticket);
                            if (this.details.isRs) {
                                this.showRsMessage = true;
                            }
                            this.serviceCompanyId = response.data.ticket.serviceCompanyId;
                            this.formChangeEmail.email =
                                response.data.ticket.customEmailAddress.email;
                            this.formChangeEmail.phone =
                                response.data.ticket.customEmailAddress.phone;
                            this.formChangeEmail.serviceCompany =
                                response.data.ticket.customEmailAddress.serviceCompany;
                            var authNumber = response.data.ticket.authNumber || {};
                            this.authForm = {
                                partNumber: authNumber.partNumber || "",
                                qty: authNumber.qty || 0,
                                techName: authNumber.techName || "",
                                id: authNumber.id || 0,
                                serviceTicketId: authNumber.serviceTicketId || 0,
                                date: authNumber.date || "",
                                authNumberString: authNumber.authNumberString ||"",
                                authNumber: (authNumber.date && authNumber.serviceTicketId && authNumber.partNumber) ? (authNumber.authNumberString) : ""
                            };
                            this.isNotWarrantyClaim =
                                response.data.ticket.coverageNumber == 2 ||
                                response.data.ticket.coverageNumber == 3 ||
                                response.data.ticket.coverageNumber == 4 ||
                                response.data.ticket.coverageNumber == 8;
                            var escalatedParts = response.data.ticket.escalatedNeededPart || {};
                            this.partsNeededForm = {
                                salesOrderNumber: escalatedParts.salesOrderNumber || "",
                                trackingNumber: escalatedParts.trackingNumber || "",
                                workflowStage: escalatedParts.workflowStage || null,
                                //smsSubscription: escalatedParts.smsSubscription || false,
                                escallationContactName: escalatedParts.escallationContactName || "",
                                escallationContactPhone: escalatedParts.escallationContactPhone || "",
                                escallationContactEmail: escalatedParts.escallationContactEmail || "",
                                escalatedBy: escalatedParts.escalatedBy || "",
                                parts: escalatedParts.parts || []
                            };
                            this.subscriberForm = response.data.subscriberList;
                            if (escalatedParts.parts != null && escalatedParts.parts.length > 0) {
                                var self = this;
                                for (let i = 0; i < escalatedParts.parts.length; i++) {
                                    api.getPartById(escalatedParts.parts[i].id, this.details.serviceCompanyId, this.isNotWarrantyClaim).then(function (responsePart) {
                                        var partForm = {
                                            part: {
                                                extendedPrice: responsePart.data.extendedPrice,
                                                name: responsePart.data.name,
                                                price: responsePart.data.price,
                                                partNo: responsePart.data.partNo,
                                            },
                                            quantity: escalatedParts.parts[i].quantity
                                        }
                                        self.partsForm.push(partForm)
                                    });
                                }
                                
                            }
                        } else {
                            this.$notify({
                                title: "Error",
                                message: response.data.message,
                                type: "error"
                            });
                            this.$emit("dialogClosed");
                        }
                    });
                }
            },
            updateSubscriber() {
                this.loading = true;
                console.log(this.subscriberForm)
                api.updateSubscriber(this.ticketId, this.subscriberForm).then(response => {
                    this.loading = false;
                    this.showSubscriptionDialog = false;
                })
                .catch(() => {
                    this.loading = false;
                });
            },
            partDialogClosed() {
                this.showAddPartsDialog = false;
            },
            partAdded(payload) {
                this.partsForm.push(payload);
            },
            showAddPart() {
                this.showAddPartsDialog = true;
            },
            resolveTicket() {
                api.resolveTicket(this.ticketId).then(response => {
                    this.closeDialog();
                    this.$emit("updated");
                });
            },
            reopenTicket() {
                api.reopenTicket(this.ticketId).then(response => {
                    this.closeDialog();
                    this.$emit("updated");
                });
            },
            print() {
                var a = this;
                api.printTicket(this.ticketId).then(response => {
                    var oHiddFrame = document.createElement("iframe");
                    oHiddFrame.style.visibility = "hidden";
                    oHiddFrame.style.position = "fixed";
                    oHiddFrame.style.right = "0";
                    oHiddFrame.style.bottom = "0";
                    oHiddFrame.src = "javascript:void(0)";
                    document.body.appendChild(oHiddFrame);
                    var dstDoc =
                        oHiddFrame.contentDocument || oHiddFrame.contentWindow.document;
                    dstDoc.write(response.data);

            setTimeout(function () {
                oHiddFrame.contentWindow.print();
                document.body.removeChild(oHiddFrame);
                }, 500);
            });
            },
            submitComment() {
                let self = this;
                this.loading = true;
                api
                    .submitComment(this.ticketId, this.form)
                    .then(response => {
                        self.loading = false;
                        self.form.comment = '';
                        if (response.data) {
                            var edited = self.details.comments.filter(
                                item => item.id === response.data.id
                            );
                            if (edited.length) {
                                edited[0].message = response.data.message;
                            } else {
                                self.details.comments.push(response.data);
                                self.details.comments = self.details.comments.sort((a, b) =>
                                    new Date(b.at) - new Date(a.at)
                                );
                            }
                        }
                    })
                    .catch(() => {
                        self.loading = false;
                    });
            },

            changeStatus() {
              this.loading = true;
              api.editServiceTicketStatus(this.ticketId, this.details.status)
                  .then(() => {
                    this.$notify({
                      title: "Success",
                      message: "Ticket status updated successfully",
                      type: "success"
                    });
                    this.$emit("statusUpdated", this.details.status);
                  })
                  .catch(error => {
                    console.error("Failed to update ticket status", error);
                    this.$notify({
                      title: "Error",
                      message: "Failed to update ticket status",
                      type: "error"
                    });
                  })
                  .finally(() => {
                    this.loading = false;
                  });
            },
            submitEscalationCommentNextStep() {
                let self = this;
                this.loading = true;
                api
                    .submitEscalationCommentNextStep(this.ticketId, this.form)
                    .then(response => {
                        self.loading = false;
                        self.form.escalationCommentNextStep = '';
                        if (response.data) {
                            var edited = self.details.escalationCommentNextStep.filter(
                                item => item.id === response.data.id
                            );
                            if (edited.length) {
                                edited[0].message = response.data.message;
                            } else {
                                self.details.escalationCommentNextStep.push(response.data);
                                self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.sort((a, b) =>
                                    new Date(b.at) - new Date(a.at)
                                );
                            }
                        }
                    })
                    .catch(() => {
                        self.loading = false;
                    });
            },
            submitEscalationSubscriber() {
                let self = this;
                this.loading = true;
                api
                    .submitEscalationSubscriber(this.ticketId, this.subscriberForm)
                    .then(response => {
                        self.loading = false;
                        //self.$refs["subscriberForm"].resetFields();                        
                        self.details.escalationSubscriberEmail = this.subscriberForm.isSubscribedByEmail;
                        self.details.escalationSubscriberSms = this.subscriberForm.isSubscribedBySms;
                    })
                    .catch(() => {
                        self.loading = false;
                    });
            },
            //editComment(comment) {
            //  this.form.comment = comment.message;
            //  this.form.commentId = comment.id;
            //},
            deleteComment(comment) {
                let self = this;
                this.$confirm(this.$t('common.areYouSureToDeleteTheComment'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteComment(this.ticketId, comment).then(response => {
                            self.loading = false;
                            self.$refs["form"].resetFields();
                            if (response.data.status === "Success") {
                                if (response.data.id) {
                                    self.details.comments = self.details.comments.filter(
                                        item => item.id !== response.data.id
                                    );
                                }
                                self.$message({
                                    type: "success",
                                    message: this.$t('common.deleteCompleted')
                                });
                            }
                            else {
                                self.$message({
                                    type: "error",
                                    message: this.$t('common.youDoNotHaveRightsToDeleteThisComment')

                                });
                            }
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            deleteEscalationCommentNextStep(comment) {
                let self = this;
                this.$confirm('Are you sure to delete the comment ?', "Warning", {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: "warning"
                })
                    .then(() => {
                        api.deleteEscalationCommentNextStep(this.ticketId, comment).then(response => {
                            self.loading = false;
                            self.$refs["form"].resetFields();
                            if (response.data.status === "Success") {
                                if (response.data.id) {
                                    self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.filter(
                                        item => item.id !== response.data.id
                                    );
                                }
                                self.$message({
                                    type: "success",
                                    message: 'Delete Completed'
                                });
                            }
                            else {
                                self.$message({
                                    type: "error",
                                    message: 'You do not have rights to delete this comment'
                                });
                            }
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            deleteEscalationCommentNextStep(comment) {
                let self = this;
                this.$confirm('Are you sure to delete the comment ?', "Warning", {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: "warning"
                })
                    .then(() => {
                        api.deleteEscalationCommentNextStep(this.ticketId, comment).then(response => {
                            self.loading = false;
                            self.$refs["form"].resetFields();
                            if (response.data.status === "Success") {
                                if (response.data.id) {
                                    self.details.escalationCommentNextStep = self.details.escalationCommentNextStep.filter(
                                        item => item.id !== response.data.id
                                    );
                                }
                                self.$message({
                                    type: "success",
                                    message: 'Delete Completed'
                                });
                            }
                            else {
                                self.$message({
                                    type: "error",
                                    message: 'You do not have rights to delete this comment'
                                });
                            }
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            showCommentFullTime(comment) {
                console.log(comment);
                var commentTime = new Date(comment.at);
                return commentTime.toLocaleString();
            },
            closeDialog() {
                this.$refs["form"].resetFields();
                this.partsForm = [];
                this.showDialog = false;
                this.$emit("dialogClosed");
            },
            loadStatuses() {
                if (this.$isAdmin) {
                    api.getStatuses().then(response => {
                        this.statuses = response.data;
                    });
                }
            },
            closePartsNeededDialog() {
                this.$refs["partsNeededForm"].resetFields();
                this.showPartsNeededDialog = false;
            },
            addEscalationPartNeeded() {
                this.details.escalationPart = this.partsNeededForm;
                this.details.escalationPart.parts = this.partsForm;
                this.showPartsNeededDialog = false;
            },
            updateTicket() {
                this.loading = true;
                api.updateTicket(this.details).then(response => {
                    this.$notify({
                        title: this.$t('common.success'),
                        message: this.$t('common.serviceTicketSuccesfullyUpdated'),
                        type: "success"
                    });
                    this.closeDialog();
                    this.$emit("updated");
                });
            },
            attachmentChanged(file, fileList) {
                this.details.attachments.push(file.raw);
            },
            attachmentRemoved(file, fileList) {
                if (file.id) {
                    var index = this.details.attachments.findIndex(
                        attachment => attachment.id === file.id
                    );
                    this.details.attachments.splice(index, 1);
                } else {
                    var index = this.details.attachments.findIndex(
                        attachment => attachment.uid == file.uid
                    );
                    this.details.attachments.splice(index, 1);
                }
            },
            handlePreview(file) {
                var split = file.name.split(".");
                this.fileExtension = split[split.length - 1];
                if (!file.url) {
                    return;
                }
                if (
                    this.fileExtension !== "jpg" &&
                    this.fileExtension !== "pdf" &&
                    this.fileExtension !== "jpeg" &&
                    this.fileExtension !== "png"
                ) {
                    window.open(file.url);
                    return;
                }
                this.fileUrlPreview = file.url;
                this.showImagePreview = true;
            },
            viewrsprocedures() {
                window.open(
                    "static/RS Procedure Technical Support.pdf",
                    "_blank",
                    "width=600,height=800,toolbar=1"
                );
                this.showRsMessage = false;
            },
            sendEmail(sendEmail, isEmailFormValied) {
                this.showResendDialog = false;
                api.resendEmail(this.details.id, this.formChangeEmail.email);
                this.details.dispatchedTo = this.formChangeEmail.serviceCompany + "<br />" +
                    this.formChangeEmail.phone + "<br />" + this.formChangeEmail.email;
            },
            accept() {
                api.accept(this.details.id).then(response => {
                    this.$notify({
                        title: this.$t('common.success'),
                        message: this.$t('common.serviceTicketAccepted'),
                        type: "success"
                    });
                    window.location.href = "/";
                });
            },
            reject() {
                this.$refs["rejectedReasonForm"].validate(valid => {
                    if (valid) {
                        this.showResendDialog = false;
                        api
                            .reject(this.details.id, this.rejectedReasonForm.rejectedReason)
                            .then(response => {
                                this.$notify({
                                    title: "Rejected",
                                    message: this.$t('common.serviceTicketRejected'),
                                    type: "success"
                                });
                                window.location.href = "/";
                            });
                    }
                });
            },
            generateAuth() {
                this.authForm.serviceTicketId = this.ticketId;
                api.generateAuthNumber(this.authForm.id, this.authForm).then(response => {
                    if (response.data.status == "Success") {
                        this.$notify({
                            title: this.$t('common.success'),
                            message: this.$t('common.authNumGenerated'),
                            type: "success"
                        });
                        this.authForm.authNumber = response.data.authNumber;
                    } else {
                        this.$notify({
                            title: "Error",
                            message: this.$t('common.authNumWasntGenerated'),
                            type: "error"
                        });
                    }

                    this.showGenerateAuthDialog = false;
                });
            },
            ShowRecommendedParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var recommendedParts = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRecommendedPart && element.part != null) {
                            recommendedParts += '' + element.part.no + '\n';
                        }
                    });
                    return recommendedParts;
                }
                else {
                    return "";
                }

            },

            ShowDescriptionForRecommendedParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var recommendedPartsDescription = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRecommendedPart && element.part != null) {
                            recommendedPartsDescription += '' + element.part.description + '\n';
                        }
                    });
                    return recommendedPartsDescription;
                }
                else {
                    return "";
                }
            },

            ShowMandatoryParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var mandatoryParts = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRequiredPart && element.part != null) {
                            mandatoryParts += '' + element.part.no + '\n';
                        }
                    });
                    return mandatoryParts;
                }
                else {
                    return "";
                }
            },

            ShowDescriptionForMandatoryParts(complaint) {
                if (complaint.partSelected.length > 0) {
                    var mandatoryPartsDescription = "";
                    complaint.partSelected.forEach(function (element) {
                        if (element.isRequiredPart && element.part != null) {
                            mandatoryPartsDescription += '' + element.part.description + '\n';
                        }
                    });
                    return mandatoryPartsDescription;
                }
                else {
                    return "";
                }
            }
        }
    };
</script>

<style scoped>
    .comment-input {
        margin-bottom: 0;
    }

        .comment-input > textarea {
            resize: none;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

    .comment-button {
        width: 100%;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-top: 0;
    }

    .comment-box {
        list-style: none;
        padding: 0;
        margin-top: 0;
        max-height: 400px;
    }

    .comment-box > li {
         margin-bottom: 10px;
    }

    .comment-box > p {
        margin-bottom: 0;
    }
    dd {
        margin-left: 0;
        line-height: 16px;
        margin-bottom: 10px;
    }

    dl {
        margin-top: 0;
    }

    dt {
        font-weight: bold;
    }

dd {
  margin-left: 0;
  line-height: 16px;
  margin-bottom: 10px;
}
.support-hours {
    padding-left: 24px;
    margin-top: 8px;
}

.support-hours li {
    padding-left: 6px;
    margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/ServiceTicketDetailsDialog.vue